import { render, staticRenderFns } from "./MultipleCollectionSelection.vue?vue&type=template&id=2433ee22&scoped=true"
import script from "./MultipleCollectionSelection.vue?vue&type=script&lang=js"
export * from "./MultipleCollectionSelection.vue?vue&type=script&lang=js"
import style0 from "./MultipleCollectionSelection.vue?vue&type=style&index=0&id=2433ee22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2433ee22",
  null
  
)

export default component.exports